import { useEffect, useState } from 'react';
import ScheduleListComponent from '../../components/schedules/ScheduleListComponent';
import { RouteComponentProps } from 'react-router-dom';
import ScheduleCreateDrawer from './ScheduleCreateDrawer';
import ScheduleDetailDrawer from './ScheduleDetailDrawer';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../modules';
import { Alert, Modal, Spin } from 'antd';
import moment from 'moment';

import {
  ScheduleListType,
  getScheduleListAsync,
} from '../../modules/schedules';
import {
  bulkCreateSchedule,
  deleteAllSchedule,
  deleteSchedule,
  getInvoiceCommon,
  importSchedule,
  updateScheduleIndex,
} from '../../api/constlink';
import ScheduleBulkCreateModal from '../../components/schedules/ScheduleBulkCreateModal';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import ScheduleImportModal from '../../components/schedules/ScheduleImportModal';

const { confirm } = Modal;

interface ScheduleListContainerProps {
  enterpriseId: string;
  projectId: string;
}

function ScheduleListContainer({
  history,
  match,
}: RouteComponentProps<ScheduleListContainerProps>) {
  const { enterpriseId, projectId } = match.params;
  const [visibleCreateDrawer, setVisibleCreateDrawer] =
    useState<boolean>(false);
  const [visibleDetailDrawer, setVisibleDetailDrawer] =
    useState<boolean>(false);
  const [openCreateModal, setOpenCreateModal] = useState<boolean>(false);
  const [gongjongList, setGongjongList] = useState<any>();
  const [openScheduleImportModal, setOpenScheduleImportModal] =
    useState<boolean>(false);
  const [projectList, setProjectList] = useState<any[]>();
  const [alertMsg, setAlertMsg] = useState<any>();
  const [loading2, setLoading2] = useState(false);

  const dispatch = useDispatch();
  const { data, loading, error } = useSelector(
    (state: RootState) => state.schedules.schedules,
  );
  const [scheduleId, setScheduleId] = useState<string>();

  useEffect(() => {
    dispatch(
      getScheduleListAsync.request({
        enterpriseId,
        projectId,
        type: ScheduleListType.TREE_LIST,
      }),
    );
  }, [enterpriseId, projectId, dispatch]);

  const onDetail = (_scheduleId: string) => {
    setScheduleId(_scheduleId);
    setVisibleDetailDrawer(true);
  };

  const onDelete = async (_scheduleId: string) => {
    await deleteSchedule({ enterpriseId, projectId, scheduleId: _scheduleId });
    dispatch(
      getScheduleListAsync.request({
        enterpriseId,
        projectId,
        type: ScheduleListType.TREE_LIST,
      }),
    );
  };

  const onCloseCreateDrawer = () => {
    setVisibleCreateDrawer(false);
  };

  const onCreateBulk = async (data: any) => {
    await bulkCreateSchedule({
      enterpriseId,
      projectId,
      nameList: data.list,
    });
    setOpenCreateModal(false);
    dispatch(
      getScheduleListAsync.request({
        enterpriseId,
        projectId,
        type: ScheduleListType.TREE_LIST,
      }),
    );
  };

  const onCloseModal = () => {
    setOpenCreateModal(false);
  };

  const _updateSchedule = async (scheduleId: string, scheduleIndex: number) => {
    const schedule = { index: scheduleIndex };
    await updateScheduleIndex({
      enterpriseId,
      projectId,
      scheduleId,
      schedule,
    });
    dispatch(
      getScheduleListAsync.request({
        enterpriseId,
        projectId,
        type: ScheduleListType.TREE_LIST,
      }),
    );
  };

  const showDeleteConfirm = () => {
    confirm({
      title: '공정 전체 삭제',
      icon: <ExclamationCircleOutlined rev={undefined} />,
      content: '공정 전체를 삭제하시겠습니까?',
      okText: '예',
      okType: 'danger',
      cancelText: '아니오',
      async onOk() {
        const res: any = await deleteAllSchedule({ enterpriseId, projectId });
        if (res.success) {
          setAlertMsg({
            message: res.message,
            isError: false,
          });
          dispatch(
            getScheduleListAsync.request({
              enterpriseId,
              projectId,
              type: ScheduleListType.TREE_LIST,
            }),
          );
        } else {
          setAlertMsg({
            message: res.message,
            isError: true,
          });
        }
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const onMenuClicked = async (key: string) => {
    if (key === '1') {
      const invoiceCommon = await getInvoiceCommon(enterpriseId);

      setGongjongList({
        list: invoiceCommon.gongjongList.map((item: any) => item.name),
      });
      setOpenCreateModal(true);
    } else if (key === '2') {
      const invoiceCommon = await getInvoiceCommon(enterpriseId);
      setProjectList(invoiceCommon.projectList);
      setOpenScheduleImportModal(true);
    } else if (key === '3') {
      showDeleteConfirm();
    }
  };

  const onCreateScheduleImport = async (data: any) => {
    setOpenScheduleImportModal(false);

    setLoading2(true);
    // await new Promise((res) => setTimeout(res, 3000));
    const res = await importSchedule({
      enterpriseId,
      projectId,
      schedule: {
        importedProjectId: data.project.id,
        baseDate: moment(data.baseDate).format('YYYY-MM-DD'),
      },
    });
    setLoading2(false);
    if (res.success) {
      setAlertMsg({
        message: res.message,
        isError: false,
      });
      dispatch(
        getScheduleListAsync.request({
          enterpriseId,
          projectId,
          type: ScheduleListType.TREE_LIST,
        }),
      );
    } else {
      setAlertMsg({
        message: res.message,
        isError: true,
      });
    }
  };

  const onCancelScheduleImport = () => {
    setOpenScheduleImportModal(false);
  };

  return (
    <>
      {loading && <Spin />}
      {error && <Alert message={`${error}`} type="error" showIcon closable />}
      {alertMsg && (
        <Alert
          message={`${alertMsg.message}`}
          type={alertMsg.isError ? 'error' : 'success'}
          showIcon
          closable
          afterClose={() => setAlertMsg(null)}
        />
      )}
      {data && (
        <Spin spinning={loading2 || loading}>
          <ScheduleListComponent
            schedules={data}
            moveToDetailPage={onDetail}
            onDelete={onDelete}
            updateSchedule={_updateSchedule}
            onMenuClicked={onMenuClicked}
          />
        </Spin>
      )}
      <ScheduleCreateDrawer
        enterpriseId={enterpriseId}
        projectId={projectId}
        visible={visibleCreateDrawer}
        onClose={onCloseCreateDrawer}
      />
      {scheduleId && (
        <ScheduleDetailDrawer
          enterpriseId={enterpriseId}
          projectId={projectId}
          scheduleId={scheduleId}
          visible={visibleDetailDrawer}
          onClose={() => {
            setVisibleDetailDrawer(false);
          }}
        />
      )}
      {openCreateModal && gongjongList && (
        <ScheduleBulkCreateModal
          onCreate={onCreateBulk}
          onCancel={onCloseModal}
          visible={openCreateModal}
          gongjongList={gongjongList}
        />
      )}
      {openScheduleImportModal && projectList && (
        <ScheduleImportModal
          projectData={projectList}
          visible={openScheduleImportModal}
          onCreate={onCreateScheduleImport}
          onCancel={onCancelScheduleImport}
        />
      )}
    </>
  );
}

export default ScheduleListContainer;
